<script setup>
import CustomerUserForm from '@frontJs/components/forms/CustomerUserForm.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, user, roles, permissions } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    user: {
        type: Object,
        required: false,
    },
    roles: {
        type: Array,
        required: true,
    },
    permissions: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title v-if="user">
            Mettre à jour l'utilisateur #{{ user.id }} - Utilisateurs -
            Datakepler
        </title>

        <title v-else>Créer un utilisateur - Utilisateurs - Datakepler</title>
    </Head>

    <PageTitle v-if="user" :tenant-name="tenant.name">
        Utilisateurs - Mettre à jour l'utilisateur #{{ user.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Utilisateurs - Créer un utilisateur
    </PageTitle>

    <CustomerUserForm
        :tenant="tenant"
        :user="user"
        :roles="roles"
        :permissions="permissions"
    />
</template>
